import { render, staticRenderFns } from "./v_Player_Profile.vue?vue&type=template&id=97f3e4e0&scoped=true&"
import script from "./v_Player_Profile.vue?vue&type=script&lang=js&"
export * from "./v_Player_Profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f3e4e0",
  null
  
)

export default component.exports